export default "__VITE_ASSET__a716f541__"